/**
 * Shop Dropdown Menu
 * Handles desktop-only click-to-open mega menu for the SHOP navigation item
 */

class ShopDropdown {
  constructor() {
    this.shopNavItem = document.querySelector('[data-nav-shop]');
    this.dropdown = document.querySelector('[data-shop-dropdown]');
    this.backdrop = document.querySelector('[data-shop-backdrop]');
    this.isDesktop = window.innerWidth >= 1024;

    // Only initialize if all elements exist
    if (!this.shopNavItem || !this.dropdown || !this.backdrop) {
      return;
    }

    this.init();
  }

  init() {
    // Update desktop check on resize
    window.addEventListener('resize', () => {
      this.isDesktop = window.innerWidth >= 1024;
      if (!this.isDesktop && this.dropdown.classList.contains('active')) {
        this.close();
      }
    });

    // Click to toggle dropdown
    this.shopNavItem.addEventListener('click', (e) => {
      e.preventDefault();
      if (!this.isDesktop) return;

      if (this.dropdown.classList.contains('active')) {
        this.close();
      } else {
        this.open();
      }
    });

    // Backdrop click to close
    this.backdrop.addEventListener('click', () => {
      this.close();
    });

    // ESC key to close
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.dropdown.classList.contains('active')) {
        e.preventDefault();
        this.close();
        this.shopNavItem.focus();
      }
    });

    // Click outside dropdown to close
    document.addEventListener('click', (e) => {
      if (!this.dropdown.classList.contains('active')) return;

      // Don't close if clicking inside dropdown or on SHOP link
      if (this.dropdown.contains(e.target) || this.shopNavItem.contains(e.target)) {
        return;
      }

      this.close();
    });

    // Product card image hover swaps
    this.initImageHoverSwaps();

    // Update dropdown position on scroll (for sticky header)
    this.updateDropdownPosition();
    window.addEventListener('scroll', () => this.updateDropdownPosition());
    window.addEventListener('resize', () => this.updateDropdownPosition());
  }

  open() {
    if (!this.isDesktop) return;

    // Update position before showing
    this.updateDropdownPosition();

    this.dropdown.classList.add('active');
    this.backdrop.classList.add('active');
    this.shopNavItem.classList.add('active');

    // ARIA attributes
    this.shopNavItem.setAttribute('aria-expanded', 'true');
    this.dropdown.setAttribute('aria-hidden', 'false');
  }

  close() {
    this.dropdown.classList.remove('active');
    this.backdrop.classList.remove('active');
    this.shopNavItem.classList.remove('active');

    // ARIA attributes
    this.shopNavItem.setAttribute('aria-expanded', 'false');
    this.dropdown.setAttribute('aria-hidden', 'true');
  }

  initImageHoverSwaps() {
    const productCards = this.dropdown.querySelectorAll('[data-product-card]');

    productCards.forEach(card => {
      const defaultImg = card.querySelector('[data-default-img]');
      const hoverImg = card.querySelector('[data-hover-img]');

      if (defaultImg && hoverImg) {
        card.addEventListener('mouseenter', () => {
          defaultImg.style.opacity = '0';
          hoverImg.style.opacity = '1';
        });

        card.addEventListener('mouseleave', () => {
          defaultImg.style.opacity = '1';
          hoverImg.style.opacity = '0';
        });
      }
    });
  }

  updateDropdownPosition() {
    if (!this.isDesktop) return;

    const header = document.querySelector('header-component');
    if (!header || !this.shopNavItem) return;

    // Get the position of the SHOP nav item
    const shopNavRect = this.shopNavItem.getBoundingClientRect();
    const headerRect = header.getBoundingClientRect();
    const dropdownRect = this.dropdown.getBoundingClientRect();

    // Calculate center position under SHOP text
    const shopCenter = shopNavRect.left + (shopNavRect.width / 2);
    const dropdownHalfWidth = dropdownRect.width / 2;
    const leftOffset = shopCenter - headerRect.left - dropdownHalfWidth;

    // Ensure dropdown doesn't overflow viewport
    const viewportWidth = window.innerWidth;
    const minLeft = 20; // 20px margin from left edge
    const maxLeft = viewportWidth - dropdownRect.width - 20; // 20px margin from right edge

    // Clamp the position between min and max
    const clampedLeft = Math.max(minLeft, Math.min(leftOffset, maxLeft));

    // Position dropdown
    const headerHeight = header.offsetHeight;
    this.dropdown.style.top = `${headerHeight + 8}px`;
    this.dropdown.style.left = `${clampedLeft}px`;
  }
}

// Initialize shop dropdown when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new ShopDropdown();
  });
} else {
  new ShopDropdown();
}

// Expose to global scope for debugging
window.ShopDropdown = ShopDropdown;
